import mockCompaniesList from './mockCompaniesList';

const MINIMUM_REQUEST_TIME_MS = 200;
const MAXIMUM_REQUEST_TIME_MS = 600;

const responseBoilerplate = {
  status: 200,
  request: {
    endpoint: 'company/search',
    code: '20eb321c-1ac5-4700-a025-0e892d74797f',
  },
  response: {
    resultsCount: 0,
    results: [],
  },
  errors: [],
};

const mockFoxentrySearchCompanyRequest = async (companyName: string) => {
  // eslint-disable-next-line no-console
  console.error('You are using mocked foxentry search company request.');

  await new Promise((resolve) => {
    setTimeout(
      resolve,
      Math.random() * MAXIMUM_REQUEST_TIME_MS + MINIMUM_REQUEST_TIME_MS,
    );
  });

  const companyNameLower = companyName.toLowerCase();

  const foundCompanies = mockCompaniesList.filter((company) => {
    return company.data.name.toLowerCase().includes(companyNameLower);
  });

  return {
    ...responseBoilerplate,
    response: {
      resultsCount: foundCompanies.length,
      results: foundCompanies,
      resultsOffset: 0,
      resultsTotal: foundCompanies.length,
    },
  };
};

export default mockFoxentrySearchCompanyRequest;
